<template>
  <div class="edit-program-stations">
    <div class="g-edit-component__top-bar">
      <slot v-if="ModalData.capabilities.steps.maxStationsPerStep === 1">
        <h2 class="edit-program-type__title">
          {{ $t('messages.programEdit.setStations.overview', {
            groupOrStep: $tc(`messages.sharedTexts.${GroupOrStep}`, 1),
            row: Current.currentRow + 1,
            time: Current.runtime
          }) }}
        </h2>
        <button
          class="g-btn--blue g-btn--rounded g-edit-component__top-bar__back-button saveAndReturn"
          @click="DoNotShowEditStations()"
        >
          <font-awesome-icon :icon="['fas', 'chevron-left']" />
          <span> {{ $t('messages.sharedTexts.controls.saveAndReturn') }}</span>
        </button>
      </slot>
      <slot v-else>
        <h2 class="edit-program-type__title">
          {{ $t('messages.programEdit.setStations.overview', {
            groupOrStep: $tc('messages.sharedTexts.' + GroupOrStep, 1),
            row: Current.currentRow + 1,
            time: Current.runtime
          }) }}
        </h2>
        <button
          class="g-btn--blue g-btn--rounded saveAndReturn"
          @click="DoNotShowEditStations()"
        >
          <font-awesome-icon :icon="['fas', 'chevron-left']" />
          <span> {{ $t('messages.sharedTexts.controls.saveAndReturn') }}</span>
        </button>
        <div class="edit-program-stations__flow">
          <h3>{{ $t('messages.programEdit.setRunTimes.flow.title') }}</h3>
          <span
            class="step-list__step__flow"
            :class="['step-list__step__flow--' + flow.className]"
            :title="flow.status"
          >
            {{ convertUnits(flow.flow ? flow.flow : 0, 'gal/min', 'l/min') }} {{ getDenominator('litre', 'gallon', 0) + '/' + $tc('messages.sharedTexts.time.m', 1) }}
          </span>
          <slot v-if="systemCapacity">
            <span>of</span>
            <span
              class="step-list__step__flow"
              :class="['step-list__step__flow--green']"
              :title="flow.status"
            >
              {{ convertUnits(systemCapacity ? systemCapacity : 0, 'gal/min', 'l/min') }} {{ getDenominator('litre', 'gallon', 0) + '/' + $tc('messages.sharedTexts.time.m', 1) }}
            </span>
          </slot>
          <p v-if="flow.className && systemCapacity">
            {{ $t(`messages.programEdit.setRunTimes.flow.${flow.className}`) }}
          </p>
        </div>
      </slot>
      <h3 v-if="GetStations.length === ModalData.capabilities.steps.maxStationsPerStep && ModalData.capabilities.steps.maxStationsPerStep !== 1">
        {{ $t('messages.programEdit.setStations.warning') }} {{ ModalData.capabilities.steps.maxStationsPerStep }}
      </h3>
    </div>

    <div class="g-two-columns g-two-columns--no-padding">
      <div class="g-two-columns__column">
        <h2 class="g-title">
          {{ $t('messages.programEdit.setStations.stationSelection') }}
        </h2>
        <div class="filter-stations">
          <select-element
            :title="$t('messages.programEdit.setStations.filter')"
            :value="'None'"
            :list="filterList"
            :emit-function-named="'setFilter'"
            @setFilter="setFilter"
          />
        </div>
      </div>

      <div class="g-two-columns__column">
        <div class="g-vertical-scroller">
          <h2
            v-if="Stations.length === 0"
            class="g-title"
          >
            {{ $t('messages.programEdit.setStations.loadingStations') }}
          </h2>
          <div class="edit-program-stations__stations-wrapper">
            <ol class="edit-program-stations__stations">
              <li
                v-for="(station, index) in Stations"
                :key="index"
                class="edit-program-stations__stations__station"
              >
                <station-component
                  v-bind="{Data: station, Type}"
                  :class="{'disabled': DisableClass(station.selected)}"
                  :store="store"
                  @StationSelectedStatus="StationSelectedStatus"
                />
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {SocketHandler, LifeCycle, UnitSystem} from '@/assets/javascript/mixins/Mixins'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import SelectElement from '@/components/elements/SelectElementReactive'
import StationComponent from '@/components/StationComponent'

export default {
  name: 'EditProgramStations',
  components:
  {
    'font-awesome-icon': FontAwesomeIcon,
    'select-element': SelectElement,
    'station-component': StationComponent
  },
  mixins: [SocketHandler, LifeCycle, UnitSystem],
  props:
  {
    ShowEditStations: {
      type: Boolean,
      default: false
    },
    store: {
      type: Object,
      default: function() {
        return{}
      }
    },
    SocketMessage: {
      type: Object,
      default: function() {
        return{}
      }
    },
    PageMessage: {
      type: Object,
      default: function() {
        return{}
      }
    },
    Current: {
      type: Object,
      default: function() {
        return {}
      }
    },
    ModalData: {
      type: Object,
      default: function() {
        return {}
      }
    },
    StationsData: {
      type: Array,
      default: function() {
        return[
          {
            Id: 0,
            stId: 0,
            name: '',
            description: '',
            isRunning: false,
            expectedFlow: 0,
            runningEntries: [],
            stStat: '',
            stTopBtnName: '',
            status: '0'
          }
        ]
      }
    },
    systemCapacity: {
      type: Number,
      default: 0
    }
  },
  data() {
    return{
      Stations: [],
      Type: 'select',
      ChangeArray: [],
      flow: {},
      filterList: [{
        value: 'None',
        label: this.$t('messages.programEdit.setStations.filterNoneLabel'),
        icon: '',
        description: this.$t('messages.programEdit.setStations.filterNoneDescription')
      }, {
        value: 'Expected Flow',
        label: this.$t('messages.programEdit.setStations.filterExpectedFlowLabel'),
        icon: '',
        description: this.$t('messages.programEdit.setStations.filterExpectedFlowDescription')
      }]
    }
  },
  computed: {
    GroupOrStep() {
      return (this.ModalData.capabilities.steps.maxStationsPerStep === 1) ? 'group' : 'step'
    },
    AllStationsSelected() {
      return this.Stations.every((station) => station.selected)
    },
    GetStations() {
      // Considder using StationSelectedStatus and a unique check
      return this.Stations.filter(station => station.selected)
    }
  },
  watch: {
    Current() {
      this.Stations = JSON.parse(JSON.stringify(this.StationsData)) // Cloning enumerables

      this.Stations.forEach((station) => {
        this.Current.currentInUse.includes(station.stId)
        ? station.selected = null
        : station.selected = !!this.Current.currentStations.find(selectedStation => station.stId === selectedStation.stId)
      })
    },
    GetStations(decoders) {
      this.$set(this, 'flow', this.getFlow(decoders))
    },
    ShowEditStations(bool) {
      if(bool) {
        this.$set(this, 'flow', this.getFlow(this.Current.currentStations))
      }
    }
  },
  methods: {
    setFilter(data) {
      if(data.value === 'Expected Flow') {
        this.Stations.sort((a, b) => {
          return parseFloat(b.expectedFlow) - parseFloat(a.expectedFlow)
        })
      } else {
        this.Stations.sort((a, b) => {
          return parseFloat(a.stId) - parseFloat(b.stId)
        })
      }
    },
    StationSelectedStatus(status, data) {
      // see getstations
      const found = this.ChangeArray.find((station) => station.stId === data.stId)

      if(found === undefined) {
        this.ChangeArray.push(data)
      }
    },
    // Not performant
    DisableClass(stationSelected) {
      if(this.ModalData.capabilities.steps.maxStationsPerStep === 1) {
        return stationSelected === null
      } else {
        if(stationSelected) {
          return false
        } else {
          return (this.GetStations.length >= this.ModalData.capabilities.steps.maxStationsPerStep && this.ModalData.capabilities.steps.maxStationsPerStep !== 1)
        }
      }
    },
    DoNotShowEditStations() {
      const clone = JSON.parse(JSON.stringify(this.ChangeArray)) // Cloning enumerables
      this.ChangeArray = []
      this.$emit('ToggleShowEditStationsFromChild', {currentRow: this.Current.currentRow, change: clone, currentStations: this.GetStations})
    },
    ToggleAllClick() {
      this.Stations.forEach((station) => {
        if(station.selected) {
          station.selected = false
        }
      })
    },
    getFlow(decoders) {
      // Get concat flow from Step
      let flowArray = [].concat.apply([], decoders.map(step => step.expectedFlow))
      let flow = 0

      flowArray.forEach((currentFlow) => {
        flow += (currentFlow !== '') ? parseInt(currentFlow) : 0
      })

      // Calculate status class
      let className = 'grey'

      if(this.systemCapacity !== 0 || flow !== 0) {
        const ratio = (flow / this.systemCapacity) * 100
        if((ratio > 0 && ratio < 10) || flow === 0) {
          className = 'grey'
        } else if(ratio >= 10 && ratio <= 50) {
          className = 'yellow'
        } else if(ratio >= 50 && ratio <= 75) {
          className = 'green'
        } else if(ratio >= 75 && ratio <= 100) {
          className = 'blue'
        } else {
          className = 'red'
        }
      }

      return {
        flow,
        className
      }
    }
  }
}
</script>

<style lang="scss">
  .saveAndReturn {
    display: inline-block; 
    float: right; 
    font-size: 16px; 
    font-family: 'Montserrat', Arial, sans-serif
  }
  .edit-program-stations {
    @include clearfix();
    background-color: $color-white;
    transition: transform 0.4s;

    .g-edit-component {
      &__top-bar {
        padding: 15px;
        line-height: 30px;
        &__back-button {
          display: inline-flex;
          align-items: center;
          text-transform: uppercase;
          > *:first-child {
            padding-right: 5px;
            position: relative;
            top: 1px;
          }
        }
      }
    }

    .edit-program-type__title {
      font-family: $font-primary-medium;
    }

    &__toggle-all-button {
      display: block;
    }

    &__stations {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
    }

    &__flow {
      display: flex;
      align-items: center;

      > * {
        margin: 0;
        padding: 0 10px !important; // @TODO: NO !important
        width: auto !important; // @TODO: NO !important
      }
    }

    .g-vertical-scroller {
      box-sizing: border-box;
      padding: 15px;
    }

    .station {
      margin-bottom: 25px;
    }
  }

  @media screen and (min-width: $bp-desktop) {
    .edit-program-stations {
      .edit-program-stations__stations-wrapper {
        padding-bottom: 25px;
        max-height: 500px;
      }
      .g-two-columns {
        display: flex;
        // height: 100%;
        &__column {
          width: 100%;
          &:first-child {
            width: auto;
            flex: 0 1 auto;
          }
        }
      }
    }

  }
</style>
